// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/scss/menu.scss
// module id = 406
// module chunks = 2